import { env } from "@/app/_utils/env";

export type PublicFestivalShow = {
  id: string;
  title: string;
  slug: string;
  start: string;
  img_url: string | null;
  ticket_price: number;
  capacity: number;
  inventory_quantity: number | null;
  held_quantity?: number;
  next_release_at?: string | null;
  max_quantity_per_order: number;
  location: { name: string; city: string } | null;
};

export type PublicFestival = {
  id: string;
  title: string;
  slug: string;
  description: string | null;
  img_url: string | null;
  published: boolean;
};

export type PublicFestivalStats = {
  nights: number;
  venues: number;
  comedians: number;
};

export type PublicFestivalDetail = {
  festival: PublicFestival;
  shows: PublicFestivalShow[];
  stats: PublicFestivalStats;
  preview: boolean;
};

export type PublicFestivalListItem = {
  slug: string;
  title: string;
};

class PublicFestivalService {
  async getFestivalBySlug(
    slug: string,
    previewToken?: string | null,
  ): Promise<PublicFestivalDetail | null> {
    const query = previewToken ? `?preview=${encodeURIComponent(previewToken)}` : "";
    const url = `${env.apiBaseUrl}festival/public/${encodeURIComponent(slug)}/${query}`;
    const res = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      cache: "no-store",
    });

    if (res.status === 404) {
      return null;
    }
    if (!res.ok) {
      throw new Error("Failed to fetch festival details");
    }

    return res.json();
  }

  async getPublishedFestivals(): Promise<PublicFestivalListItem[]> {
    const url = `${env.apiBaseUrl}festival/public/`;
    const res = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      cache: "no-store",
    });

    if (!res.ok) {
      throw new Error("Failed to fetch published festivals");
    }

    return res.json();
  }
}

export default new PublicFestivalService();
